import { useContext } from 'react';
import { TransactionsTableContext, ITransactionsTableContext } from './TransactionsTableContext';

export const useTransactionsTable = () => useContext<ITransactionsTableContext>(TransactionsTableContext);
